import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import {debounceTime, filter, finalize} from 'rxjs/operators';
import { IAvailableTypes, IConstantItem } from 'src/app/core/models/available-types.interface';
import { ICountry } from 'src/app/core/models/country.interface';
import { PageParams } from 'src/app/core/models/page-params.model';
import { ConstantService } from 'src/app/core/services/constant.service';
import { MarketplacesService } from 'src/app/core/services/marketplaces.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { UserService } from 'src/app/core/services/user.service';
import {
    ConsolidateShipmentsDetailsComponent
} from 'src/app/modules/consolidate-shipments/components/consolidate-shipments-details/consolidate-shipments-details.component';
import { OrderType } from 'src/app/shared/enums/order-type.enum';
import { Roles } from 'src/app/shared/enums/role-types.enum';
import { SaleOrderStatus } from 'src/app/shared/enums/sale-order-status.enum';
import { SaleOrderType } from 'src/app/shared/enums/sale-order-type.enum';
import { ConfirmPopupDialog } from 'src/app/shared/popups/confirm-popup/confirm-popup.component';
import { CustomerPopupDialog } from 'src/app/shared/popups/customer-popup/customer-popup.component';
import {
    HideShowFieldsComponent
} from 'src/app/shared/popups/hideshow-fields/hideshowfields.component';
import {
    OriginCountryPopupDialog
} from 'src/app/shared/popups/origin-country/origin-country-popup.component';

import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';

import { PlaceStatus } from '../../../../shared/enums/place-status.enum';
import { RegistrationService } from '../../../customer-registration/services/registration.service';
import { LocalStorageService } from '../../../empact-shop/core/services/local-storage.service';
import {ConfirmAssignComponent} from '../../../invoice-manager/components/confirm-assign/confirm-assign.component';
import {
    SpecificInvoiceListDialogComponent
} from '../../../invoice-manager/components/specific-invoice-list-dialog/specific-invoice-list-dialog.component';
import {EAssignType} from '../../../invoice-manager/editor/editor.component';
import {InvoiceManagementService} from '../../../invoice-manager/invoice-management.service';
import {
    SaleOrderDetailsComponent
} from '../../components/sale-order-details/sale-order-details.component';
import {
    XlsxUploadPopupPopupComponent
} from '../../invat-order-search-page/xlsx-upload-popup/xlsx-upload-popup.component';
import { IOrderListItem } from '../../models/order-list-item';
import { ISaleOrder } from '../../models/sale-order.interface';
import { SaleOrderService } from '../../services/sale-order.service';
import { SaleOrderExportPollerService } from '../../services/sale-order-export-poller.service';
import { ExportProgressDialogComponent } from '../../components/export-progress-dialog/export-progress-dialog.component';
import { FieldList } from './hideshow-fields-param';
import { ShipmentSubType } from 'src/app/shared/enums/shipment-subtype.enum';
import { ShipmentSubtypeSelectPopupComponent } from 'src/app/shared/popups/shipment-subtype-select-popup/shipment-subtype-select-popup.component';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import { buildSaleOrderExportColumns, resolveEffectiveFieldListForExport } from '../../utils/sale-order-export-columns.util';
import { PartnerService } from 'src/app/modules/partner-management/services/partner.service';
import { BatchService } from 'src/app/modules/batch/service/batch.service';
import { deliveredStatuses } from 'src/app/core/constants.enum';
import {
    IStatusType,
    SaleOrderStatusCategory,
} from '../../models/status-type.interface';
import { DeliveryStatusLabelPipe } from 'src/app/shared/pipes/delivery-status-label.pipe';

const Field_List: FieldList[] = [
    {
        key: 'reorder',
        value: false,
        label: 'Reorder'
    },
    {
        key: 'eciOrderDate',
        value: false,
        label: 'Empact Order Date'
    },
    {
        key: 'orderId',
        value: false,
        label: 'Order Id'
    },
    {
        key: 'stripeAmount',
        value: false,
        label: 'Stripe Amount'
    },
    {
        key: 'stripeRefundAmount',
        value: false,
        label: 'Stripe Refund Amount'
    },
    {
        key: 'marketplaceVat',
        value: false,
        label: 'Market place VAT'
    },
    {
        key: 'conversionRate',
        value: false,
        label: 'Conversion Rate'
    },
    {
        key: 'empactVatAmountEur',
        value: false,
        label: 'Empact VAT Amount (EUR)'
    },
    {
        key: 'empactTotalOrderAmountEur',
        value: false,
        label: 'Emapct Total Order Amount (EUR)'
    },
    {
        key: 'eciVat',
        value: false,
        label: 'Amount Exc.VAT'
    },
];

@Component({
    selector: 'eci-b2b-sale-orders-search-page',
    templateUrl: './b2b-sale-orders-search-page.component.html',
    styleUrls: ['./b2b-sale-orders-search-page.component.scss']
})
export class B2BSaleOrdersSearchPageComponent implements OnInit {

    pageParams: PageParams = new PageParams();
    nextCursor: string | null = null;
    isLoading = false;
    hasMore = true;
    fromData: FormControl = new FormControl('');
    toData: FormControl = new FormControl('');

    fromDataEmpact: FormControl = new FormControl('');
    toDataEmpact: FormControl = new FormControl('');

    deliveryFromDate: FormControl = new FormControl('');
    deliveryToDate: FormControl = new FormControl('');

    marketplaces: FormControl = new FormControl(null);
    operationalStatus: FormControl = new FormControl(null);
    financialStatus: FormControl = new FormControl(null);
    orderStatus: FormControl = new FormControl(null);
    //customerType: FormControl = new FormControl(null);// Deprecate Company type
    searchStr = new FormControl('');
    searchCountry = new FormControl('');
    searchorMarketplaces: FormControl = new FormControl('');
    searchOperationalStatus: FormControl = new FormControl('');
    searchFinancialStatus: FormControl = new FormControl('');
    searchorderStatus: FormControl = new FormControl('');
    operationalStatusOptions: IStatusType[] = [];
    financialStatusOptions: IStatusType[] = [];
    //searchcustomerType: FormControl = new FormControl('');// Deprecate Company type
    searchCustomerName: FormControl = new FormControl('');
    customerName: FormControl = new FormControl('');
    amountType: FormControl = new FormControl('');
    showBatchBtn: boolean = true;
    
    originCountry: FormControl = new FormControl('');
    originSearchCountry = new FormControl('');
    availableOriginCountries: ICountry[];

    destinationCountry: FormControl = new FormControl('');
    destinationSearchCountry = new FormControl('');
    availableDestinationCountries: ICountry[];

    shopIdByfilter: FormControl = new FormControl('');
    searchShopIdDropDown = new FormControl('');
    currentSort: Sort;
    sumOfTotalFIelds: any = [];
    sumOfTotalFIeldsIncludingCancelled: any = [];
    previousUrl: string = null;
    currentUrl: string = null;
    saleOrdersList: ISaleOrder[];
    availableTypes: IAvailableTypes;
    showLoader: boolean = false;

    listOfSelectedItems: number[] = [];
    listOfSelectedItemsBody: ISaleOrder[] = [];
    existingConsolOrderIds: number[] = [];

    previousePageCustomer: number = 0;
    totalPagesCustomers: number = 0;

    companyList: any[];
    routeSubscription: Subscription;
    amountTypes: Array<object>;
    fullCountriesList: ICountry[];

    getAllShops: any = [];
    previousPageShops: number = 0;
    totalPagesShops: number = 1;
    isLoadingShops: boolean = false;
    private shopRequestId = 0;
    packageId: number;
    addNewSaleOrder: boolean = false;

    fieldList = Field_List;

    batchOriginCountry: FormControl = new FormControl('');
    batchDestinationCountry: FormControl = new FormControl('');

    batchIdfilter: FormControl = new FormControl(null);
    batchSearchId: FormControl = new FormControl('');

    partnerIdfilter: FormControl = new FormControl(null);
    partnerSearchId: FormControl = new FormControl('');
    partnerList = [];

    batchIdList = [];

    fileNameFilter: FormControl = new FormControl('');
    fileNameSearchId: FormControl = new FormControl('');
    fileNameList = [];
    previousPageFileNames: number = 0;
    totalPagesFileNames: number = 1;
    isLoadingFileNames: boolean = false;
    private fileNameRequestId = 0;

    @ViewChild('marketplaceSelect', { static: true }) marketplaceSelect: MatSelect;
    @ViewChild('operationalStatusSelect', { static: true }) operationalStatusSelect: MatSelect;
    @ViewChild('financialStatusSelect', { static: true }) financialStatusSelect: MatSelect;
    @ViewChild('orderStatusSelect', { static: true }) orderStatusSelect: MatSelect;
    @ViewChild('shopNameSelect', { static: true }) shopNameSelect: MatSelect;
    @ViewChild('companySelect', { static: true }) companySelect: MatSelect;
    @ViewChild('originCountrySelect', { static: true }) originCountrySelect: MatSelect;
    @ViewChild('destinationCountrySelect', { static: true }) destinationCountrySelect: MatSelect;
    @Input() showConsolidateBtn: boolean = true;
    @ViewChild('fileInput') fileInput: any;

    sub$: Subscription = new Subscription();

    public is4ConsolShipment: boolean = false;
    public shipmentSubtype: ShipmentSubType = ShipmentSubType.Regular;

    get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    get isDelegateAdmin(): boolean {
        return this.userSvc.userStorage.role == Roles.DelicateAdmin;
    }

    constructor(
        private router: Router,
        public localStorageSvc: LocalStorageService,
        public userSvc: UserService,
        private dialog: MatDialog,
        private saleOrderSvc: SaleOrderService,
        private datePipe: DatePipe,
        private constSvc: ConstantService,
        private notify: NotificationService,
        private marketplaceSvc: MarketplacesService,
        private regSvc: RegistrationService,
        public uploadFileSvc: UploadFileService,
        public route: ActivatedRoute,
        private invoiceManagementService: InvoiceManagementService,
        private consolidateShipmentService: ConsolidateShipmentService,
        private partnerService: PartnerService,
        private batchService: BatchService,
        private deliveryStatusLabelPipe: DeliveryStatusLabelPipe,
        private exportPoller: SaleOrderExportPollerService,
    ) {
        this.amountTypes = [
            { 'id': '0', 'name': 'All' },
            { 'id': '1', 'name': 'up to 150' },
            { 'id': '2', 'name': 'over to 150' },
        ]
    }

    displayedColumns: string[] = [
        'checkboxes',
        'operationalStatus',
        'financialStatus',
        'downloadParcelLabel',
        'parcelCount',
        'donwloadDocuments',
        'reorder',
        'returns',
        'eciOrderDate',
        'orderDate',
        'originCountryName',
        'countryName',
        'customerName',
        'shopId',
        'shopName',
        'impShipment',
        'orderID',
        'morderID',
        'shipmentId',
        'carrier',
        'trackingNumber',
        'orderCurrency',
        'stripeAmount',
        'stripeRefundAmount',
        'conversionRate',
        'eciVat',
        'totalWithoutVat',
        'vatCharges',
        'empactVatAmountEur',
        'empactTotalOrderAmountEur',
        'orderAmount',
        'marketPlace',
        'deliveryDate',
        // 'orderStatus', // Hidden: legacy sale_orders.status column; use operationalStatus + financialStatus instead.
        'eciSellOrderTotalTest',
        'shippingPriceTest',
        'productsTest',
    ];
    dataSource;

    // Deprecate Company type
    // get customerTypes(): IConstantItem[] {
    //     if (!this.availableTypes) {
    //         return;
    //     }
    //     return this.availableTypes.CompanyType;
    // }

    get marketplaceTypes(): IConstantItem[] {
        return this.marketplaceSvc?.availableMarketplaces$?.getValue();
    }

    get orderStatuses(): IConstantItem[] {
        if (!this.availableTypes) {
            return;
        }
        return this.availableTypes.SaleOrderStatus;
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        // commented because it's creating an error when we are logout
        // bug https://github.com/Zangula/ECommIn_project_management/issues/3569
        // const req = {
        //     name: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE',
        //     label: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE Listview Fields setting',
        //     value: JSON.stringify(Field_List)
        // };
        // this.constSvc.saveSettings(req).subscribe(data => {
        //     this.routeSubscription && this.routeSubscription.unsubscribe();
        //     if (!data) {
        //         return;
        //     }
        // });
    }

    ngOnInit(): void {
        this.loadStatusTypeFilterOptions();
        if (this.isAdmin) {
            this.getPartnersList();
            this.getListOfBatches();
        }
        this.getListOfFileName();
        this.route.queryParams.subscribe(vals => {
            if (vals.consolShipment && Number(vals.consolShipment) === 1) {
                this.is4ConsolShipment = true;
            }
        });

        this.getListOfCountries('', 1);
        this.getAllShopsData();
        if (this.userSvc.isOfflineCustomer || this.isAdmin) {
            this.displayedColumns.push(
                'buyerName',
                'paymentTerms',
                // 'syncAftershipRefresh',

            );
        }

        if(this.isAdmin){
            this.displayedColumns.splice(14, 0, 'batchId');
            this.displayedColumns.splice(15, 0, 'consolNumber');
            this.displayedColumns.splice(16, 0, 'batchOriginCountryName');
            this.displayedColumns.splice(17, 0, 'batchDestinationCountryName');
            this.displayedColumns.splice(18, 0, 'fileName');
            this.displayedColumns.splice(19, 0, 'batchType');
        } else {
            this.displayedColumns.splice(15, 0, 'regularConsolNumber');
        }

        this.routeSubscription = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            if (event.url != '/') {
                this.previousUrl = this.currentUrl;
                this.currentUrl = event.url;
                // commented because it's creating an error when we are logout
                // bug https://github.com/Zangula/ECommIn_project_management/issues/3569
                // if (this.previousUrl != this.currentUrl && this.currentUrl != '/sales-order-management/b2b-sales-order-management') {
                //     const req = {
                //         name: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE',
                //         label: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE Listview Fields setting',
                //         value: JSON.stringify(this.fieldList)
                //     };
                //     this.constSvc.saveSettings(req).subscribe(data => {
                //         this.routeSubscription && this.routeSubscription.unsubscribe();
                //         if (!data) {
                //             return;
                //         }
                //     });
                // }
            }
        });

        this.originSearchCountry.valueChanges.subscribe(value => {
            if (value) {
                this.availableOriginCountries = this.fullCountriesList.filter(c => c.name.toLowerCase().includes(value.toLowerCase()));
            } else {
                this.availableOriginCountries = this.fullCountriesList;
            }
        });

        this.destinationSearchCountry.valueChanges.subscribe(value => {
            if (value) {
                this.availableDestinationCountries = this.fullCountriesList.filter(c => c.name.toLowerCase().includes(value.toLowerCase()));
            } else {
                this.availableDestinationCountries = this.fullCountriesList;
            }
        });

        this.searchShopIdDropDown.valueChanges
            .pipe(debounceTime(500))
            .subscribe((value) => {
                this.previousPageShops = 0;
                this.getAllShopsData(1, 20, value || '');
            });
        if (this.userSvc.isAdmin) {
            this.customerName.valueChanges.subscribe(() => {
                this.shopIdByfilter.reset();
                this.searchShopIdDropDown.reset();
                this.previousPageShops = 0;
                this.getAllShopsData(1, 20, '');
            });
        }
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, this.pageParams.pageSize, '') : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
        this.constSvc.availableTypes.subscribe(data => {
            this.availableTypes = data;
        });

        this.searchStr.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.search();
        });
        this.getListCompanies();

        this.searchCustomerName.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousePageCustomer = 0;
            this.getListCompanies();
        });

        this.fileNameSearchId.valueChanges.pipe(debounceTime(500)).subscribe(value => {
            this.previousPageFileNames = 0;
            this.getListOfFileName(1, 20, value || '');
        });

        this.constSvc.getAvailableCountries().subscribe(data => {
            this.fullCountriesList = data;
        });
        this.loadStatusTypeFilterOptions();
    }

    private loadStatusTypeFilterOptions(): void {
        this.saleOrderSvc.getStatusTypes().subscribe((statusTypes: IStatusType[]) => {
            this.operationalStatusOptions = this.mapStatusOptionsForSearch(
                (statusTypes || []).filter((row) => row.statusType === SaleOrderStatusCategory.OPERATIONAL),
            );
            this.financialStatusOptions = this.mapStatusOptionsForSearch(
                (statusTypes || []).filter((row) => row.statusType === SaleOrderStatusCategory.FINANCIAL),
            );
        });
    }

    private mapStatusOptionsForSearch(options: IStatusType[]): IStatusType[] {
        return options.map((row) => ({
            ...row,
            name: this.deliveryStatusLabelPipe.transform(row.empactStatusId),
        }));
    }

    getPartnersList(): void {
        this.partnerService.getPartnersList().subscribe((result) => {
            this.partnerList = result;
        });
    }

    getListOfBatches(
        partnerId = this.isPartner ? this.userSvc.user.id : ''
    ): void {
        this.batchService.getBatchIdList(partnerId).subscribe((result) => {
            this.batchIdList = result;
        });
    }

    getListOfFileName(
        page: number = this.previousPageFileNames + 1,
        limit: number = 20,
        q: string = this.fileNameSearchId.value
    ): void {
        if (page > 1 && (this.isLoadingFileNames || this.previousPageFileNames >= this.totalPagesFileNames)) {
            return;
        }
        const requestId = ++this.fileNameRequestId;
        this.isLoadingFileNames = true;
        this.saleOrderSvc.getfileName(page, limit, q || '').subscribe(
            (result) => {
                if (requestId !== this.fileNameRequestId) {
                    return;
                }
                const items = Array.isArray(result) ? result : result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingIds = new Set(
                        this.fileNameList.map((file) => file.xlsx_sale_order_files_id)
                    );
                    this.fileNameList = [
                        ...this.fileNameList,
                        ...items.filter(
                            (file) => !existingIds.has(file.xlsx_sale_order_files_id)
                        ),
                    ];
                } else {
                    this.fileNameList = this.keepSelectedFiles(items);
                }
                this.previousPageFileNames = meta?.currentPage || page;
                this.totalPagesFileNames = meta?.totalPages || 1;
                this.isLoadingFileNames = false;
            },
            () => {
                if (requestId === this.fileNameRequestId) {
                    this.isLoadingFileNames = false;
                }
            }
        );
    }

    onFileNameDropdownOpened(): void {
        this.previousPageFileNames = 0;
        this.getListOfFileName(1, 20, this.fileNameSearchId.value || '');
    }

    private keepSelectedFiles(files: any[] = []): any[] {
        const selectedIds = this.fileNameFilter?.value;
        if (!selectedIds || (Array.isArray(selectedIds) && selectedIds.length === 0)) {
            return files;
        }
        const ids = Array.isArray(selectedIds) ? selectedIds : [selectedIds];
        const selected = this.fileNameList.filter(
            (file) =>
                ids.some((id) => id == file.xlsx_sale_order_files_id) &&
                !files.some((item) => item.xlsx_sale_order_files_id == file.xlsx_sale_order_files_id)
        );
        return selected.length ? [...files, ...selected] : files;
    }

    get isPartner(): boolean {
        return this.userSvc.userStorage.role == Roles.PartnerAccount;
    }

    getPackageType(
        companyId: number = this.userSvc.company.id
    ): void {
        this.userSvc.getPackageTypeByCompanyId(companyId).subscribe(response => {
            this.packageId = response.packageId;
        })
    }

    getListOfCountries(
        q: string,
        page: number,
        limit: number = 1000,
    ): void {
        this.constSvc.getAvailableCountriesForScroll(page, limit, false, q).subscribe(data => {
            if (!data) { return; }
            this.fullCountriesList = data.items;
            this.availableOriginCountries = data.items;
            this.availableDestinationCountries = data.items;
        });
    }

    clearFilters(): void {
        this.searchStr = new FormControl('');
        this.fromData = new FormControl('');
        this.fromDataEmpact = new FormControl('');
        this.toData = new FormControl('');
        this.toDataEmpact = new FormControl('');
        this.marketplaces = new FormControl(null);
        this.operationalStatus = new FormControl(null);
        this.financialStatus = new FormControl(null);
        this.orderStatus = new FormControl(null);
        this.customerName = new FormControl('');
        this.amountType = new FormControl('');
        this.shopIdByfilter = new FormControl('');
        this.originCountry = new FormControl('');
        this.destinationCountry = new FormControl('');
        this.deliveryFromDate = new FormControl('');
        this.deliveryToDate = new FormControl('');
        this.batchIdfilter = new FormControl(null);
        this.partnerIdfilter = new FormControl(null);
        this.fileNameFilter = new FormControl('');
        this.batchOriginCountry = new FormControl('');
        this.batchDestinationCountry = new FormControl('');
        this.searchShopIdDropDown.reset();
        this.search();
    }

    isDataNotCorrect(item: FormControl): boolean {
        return item.value === null;
    }

    selectAllData(): void {
        this.dataSource = [];
        this.saleOrdersList = [];
        this.getList(
            1,
            -1,
            this.searchStr.value,
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.customerName.value
                : this.userSvc.company.id,
            true
        );
    }

    pageChanged(e: PageParams): void {
        this.pageParams.pageIndex = e.pageIndex;
        this.pageParams.pageSize = e.pageSize;
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
            ? this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value)
            : this.getList(e.pageIndex + 1, e.pageSize, this.searchStr.value, this.userSvc.company.id);
    }

    reloadList(): void {
        this.dataSource = [];
        this.saleOrdersList = [];
        this.pageParams.pageIndex = 0;
        this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
            ? this.getList(1, this.pageParams.pageSize, '')
            : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
    }

    getList(
        page: number = this.pageParams.pageIndex + 1,
        limit: number = this.pageParams.pageSize,
        q: string = this.searchStr.value,
        companyId: number = this.customerName.value,
        isSelectAll: boolean = false,
        batchId: number = this.batchIdfilter.value,
        partnerId: number = this.partnerIdfilter.value,
        fileId: number = this.fileNameFilter.value,
        batchCountryOrigin: string = this.batchOriginCountry.value,
        batchCountryDestination: string = this.batchDestinationCountry.value,
        amountType: string = this.amountType.value,
        originCountry: string = this.originCountry.value,
        destinationCountry: string = this.destinationCountry.value,
        shopId: string = this.shopIdByfilter.value,
        orderField: string = this.currentSort?.active || '',
        orderDir: string = this.currentSort?.direction.toUpperCase() || '',
    ): void {
        if (!isSelectAll && this.isLoading) {
            return;
        }
        this.isLoading = true;
        this.showLoader = true;
        this.saleOrderSvc
            .getOrdersB2CTest(
                page,
                limit,
                q,
                companyId,
                batchId,
                partnerId,
                fileId,
                amountType,
                '',
                shopId,
                this.prepareSearchParams,
                orderField,
                orderDir,
                false,
                SaleOrderType.IsB2B.toString(),
                false,
                PlaceStatus.Confirmed,
                {
                    originCountry,
                    destinationCountry,
                    batchCountryOrigin,
                    batchCountryDestination,
                    dateToEmpact: this.toDataEmpact.value
                        ? this.datePipe.transform(
                              this.toDataEmpact.value,
                              'yyyy-MM-dd'
                          )
                        : '',
                    dateFromEmpact:
                        this.toDataEmpact.value && this.fromDataEmpact.value
                            ? this.datePipe.transform(
                                  this.fromDataEmpact.value,
                                  'yyyy-MM-dd'
                              )
                            : '',
                    deliveryDateTo: this.deliveryToDate.value
                        ? this.datePipe.transform(
                              this.deliveryToDate.value,
                              'yyyy-MM-dd'
                          )
                        : '',
                    deliveryDateFrom:
                        this.deliveryFromDate.value &&
                        this.deliveryFromDate.value
                            ? this.datePipe.transform(
                                  this.deliveryFromDate.value,
                                  'yyyy-MM-dd'
                              )
                            : '',
                },
                isSelectAll
            )
            .subscribe({
                next: (data) => {
                    this.isLoading = false;
                    this.showLoader = false;
                    if (!data) {
                        return;
                    }
                    if (isSelectAll) {
                        this.listOfSelectedItems = data.items.map(item => item.id);
                        this.listOfSelectedItemsBody = [];
                        return;
                    }

                    const duplicates = this.findDuplicate(data.items);
                    for (const item of data.items) {
                        if (duplicates.length > 0) {
                            const marketplaceOrderId =
                                item?.marketplace?.marketplaceOrderId?.length > 6
                                    ? item?.marketplace?.marketplaceOrderId?.slice(-5)
                                    : item?.marketplace?.marketplaceOrderId;

                            if (duplicates.indexOf(marketplaceOrderId) > -1) {
                                item['color'] = '#eba5a5';
                            }
                        }
                    }

                    this.dataSource = data.items;
                    this.saleOrdersList = this.dataSource;

                    this.pageParams.pageSize = data.meta.itemsPerPage;
                    this.pageParams.pageIndex = data.meta.currentPage - 1;
                    this.pageParams.length = data.meta.totalItems;

                    this.sumOfTotalFIeldsIncludingCancelled = data.totals?.[0];
                    this.sumOfTotalFIelds = data.totals?.[0];
                },
                error: (err) => {
                    console.error('sale Order error:', err);
                    this.isLoading = false;
                    this.showLoader = false;
                }
            });
    }

    /*toggleAllSelection(control: FormControl, option: MatOption, countries: ICountry[]) {
        if (option.selected) {
            control
                .patchValue([...countries.map(item => item.name), 0]);
        } else {
            control.patchValue([]);
        }
    }*/

    toggleAllEUSelection(control: FormControl, option: MatOption, countries: ICountry[], fieldName = 'name') {
        if (option.selected) {
            const selectedCountries: unknown[] = [];
            countries.map(item => {
                if (item.isEurope) {
                    selectedCountries.push(item[fieldName as keyof ICountry]);
                }
            });
            control
                .patchValue([...selectedCountries, 0]);
        } else {
            control.patchValue([]);
        }
    }

    toggleAllNonEUSelection(control: FormControl, option: MatOption, countries: ICountry[], fieldName = 'id') {
        if (option.selected) {
            const selectedCountries: unknown[] = [];
            countries.map(item => {
                if (!item.isEurope) {
                    selectedCountries.push(item[fieldName as keyof ICountry]);
                }
            });
            control
                .patchValue([...selectedCountries, -1]);
        } else {
            control.patchValue([]);
        }
    }

    public getValueShopNameFilter(shop: { shopName?: string; shopId?: string }): string {
        return `${shop.shopName}(${shop.shopId})`;
    }

    getAllShopsData(
        page: number = this.previousPageShops + 1,
        limit: number = 20,
        q: string = this.searchShopIdDropDown.value
    ): void {
        if (page > 1 && (this.isLoadingShops || this.previousPageShops >= this.totalPagesShops)) {
            return;
        }
        const requestId = ++this.shopRequestId;
        this.isLoadingShops = true;
        this.saleOrderSvc.getAllShops(q || '', page, limit).subscribe(
            (result) => {
                if (requestId !== this.shopRequestId) {
                    return;
                }
                const items = Array.isArray(result) ? result : result?.items || [];
                const meta = result?.meta;
                if (meta?.currentPage > 1) {
                    const existingKeys = new Set(
                        this.getAllShops.map((shop) => this.getValueShopNameFilter(shop))
                    );
                    this.getAllShops = [
                        ...this.getAllShops,
                        ...items.filter(
                            (shop) => !existingKeys.has(this.getValueShopNameFilter(shop))
                        ),
                    ];
                } else {
                    this.getAllShops = this.keepSelectedShops(items);
                }
                this.previousPageShops = meta?.currentPage || page;
                this.totalPagesShops = meta?.totalPages || 1;
                this.isLoadingShops = false;
            },
            () => {
                if (requestId === this.shopRequestId) {
                    this.isLoadingShops = false;
                }
            }
        );
    }

    onShopDropdownOpened(): void {
        this.previousPageShops = 0;
        this.getAllShopsData(1, 20, this.searchShopIdDropDown.value || '');
    }

    private keepSelectedShops(shops: any[] = []): any[] {
        const selectedValues = this.shopIdByfilter?.value;
        if (!selectedValues || (Array.isArray(selectedValues) && selectedValues.length === 0)) {
            return shops;
        }
        const values = Array.isArray(selectedValues) ? selectedValues : [selectedValues];
        const selected = this.getAllShops.filter(
            (shop) =>
                values.some((value) => value == this.getValueShopNameFilter(shop)) &&
                !shops.some(
                    (item) => this.getValueShopNameFilter(item) === this.getValueShopNameFilter(shop)
                )
        );
        return selected.length ? [...shops, ...selected] : shops;
    }

    trackByShopId(index: number, shop: any): number | string {
        return shop?.id ?? shop?.shopId ?? index;
    }

    trackByCompanyId(index: number, company: any): number | string {
        return company?.id ?? index;
    }

    trackByFileId(index: number, file: any): number | string {
        return file?.xlsx_sale_order_files_id ?? index;
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(SaleOrderDetailsComponent, {
            maxHeight: '600px',
            width: '900px'
        });
        dialogRef.componentInstance.createMode = true;
        dialogRef.componentInstance.isB2BSaleOrder = true;
        dialogRef.componentInstance.header = 'Sales Management - Add Sales Order';
        dialogRef.componentInstance.marginTop = '0';
        dialogRef.afterClosed().subscribe(result => {
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, this.pageParams.pageSize, '') : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
        });
    }

    openCustomerDialog(): void {
        const dialogRef = this.dialog.open(CustomerPopupDialog);
        dialogRef.afterClosed().subscribe(result => {
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, this.pageParams.pageSize, '') : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
        });
    }

    get prepareSearchParams(): any {
        return {
            marketplaces: this.marketplaces.value ? this.marketplaces.value : '',
            //companyTypes: this.customerType.value ? this.customerType.value : '',// Deprecate Company type
            dateTo: this.toData.value && this.toData.value !== null ? this.datePipe.transform(this.toData.value, 'yyyy-MM-dd') : '',
            dateFrom: this.toData.value && this.fromData.value !== null ? this.datePipe.transform(this.fromData.value, 'yyyy-MM-dd') : '',
            orderStatus: this.orderStatus.value ? this.orderStatus.value : '',
            operationalStatus: this.operationalStatus.value ?? '',
            financialStatus: this.financialStatus.value ?? '',
        };
    }

    sortData(sort: Sort): void {
        if (!sort.active || sort.direction === '') {
            return;
        }

        this.dataSource = [];
        this.saleOrdersList = [];
        this.pageParams.pageIndex = 0;
        this.currentSort = sort;
        this.getList(
            1,
            this.pageParams.pageSize,
            this.searchStr.value || '',
            (this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin)
                ? this.customerName.value
                : this.userSvc.company.id,
        );
    }

    search(): void {
        this.listOfSelectedItems = [];
        this.listOfSelectedItemsBody = [];
        this.dataSource = [];
        this.saleOrdersList = [];
        this.pageParams.pageIndex = 0;
        this.getList(
            1,
            this.pageParams.pageSize,
            this.searchStr.value,
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
                ? this.customerName.value
                : this.userSvc.company.id,
        );
    }

    deleteOrders(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.deleteOrders(this.listOfSelectedItems).subscribe(() => {
                this.reloadList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Deleted successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    regenerateOrdersInvoice(): void {
        if (!this.listOfSelectedItems) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm regeneration of invoice';
        dialogRef.componentInstance.rightBtnText = 'Regenerate Invoice';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.regenrateOrdersInvoice(this.listOfSelectedItems).subscribe(() => {
                this.reloadList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Invoice Regenerated successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    deleteDuplicateds(): void {
        if (!this.customerName?.value) {
            return;
        }
        const dialogRef = this.dialog.open(ConfirmPopupDialog);
        dialogRef.componentInstance.message = 'Please confirm deleting';
        dialogRef.componentInstance.rightBtnText = 'Delete';
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            this.saleOrderSvc.deleteMultipleOrder({ companyId: this.customerName?.value }).subscribe(() => {
                this.reloadList();
                this.listOfSelectedItems = [];
                this.notify.showSuccessMessage('Deleted successfully');
            }, err => {
                this.notify.showSuccessMessage('Something went wrong');
                console.log('Error => ', err);
            });
        });
    }

    getListCompanies(q: string = this.searchCustomerName.value): void {
        q = this.customerName.value ? this.searchCustomerName.value : q;
        this.regSvc.getCompanyListForSales(q).subscribe(data => {
            if (!data) {
                return;
            }
            this.companyList = data;
        });
    }

    clearSelection() {
        this.customerName.reset();
        this.shopIdByfilter.reset();
        this.searchShopIdDropDown.reset();
        this.previousPageShops = 0;
        this.getAllShopsData(1, 20, '');
        this.getListCompanies(this.searchCustomerName.value);
        this.listOfSelectedItems =[];
        this.listOfSelectedItemsBody = [];
    }

    downloadDoc(element): void {
        this.saleOrderSvc.downloadFile(element?.id, element?.orderDocuments[0]?.id);
    }

    uploadDoc(el: { saleOrderId: number, id: number, e: any, file: any }): void {
        const files = el.e.dataTransfer ? el.e.dataTransfer.files : el.e.target.files;

        this.saleOrderSvc.fileLoadedObserver.subscribe(() => {
            //this.getList();
            this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin ? this.getList(1, this.pageParams.pageSize, '') : this.getList(1, this.pageParams.pageSize, '', this.userSvc.company.id);
        })

        this.saleOrderSvc.uploadFile(files, el.saleOrderId, el.id);
    }

    updateDocs(id, body, element): void {
        this.saleOrderSvc.updateOrderDoc(element?.id, id, body).subscribe(data => {
            this.notify.showSuccessMessage('Document Uploaded');
        });
    }

    exportToExcel(): void {
        if (this.exportPoller.isExportInProgress) {
            this.dialog.open(ExportProgressDialogComponent, {
                width: '440px',
                disableClose: true,
                data: { alreadyInProgress: true },
            });
            return;
        }

        const exportColumns = buildSaleOrderExportColumns({
            displayedColumns: this.displayedColumns,
            fieldList: resolveEffectiveFieldListForExport(
                this.fieldList,
                'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE',
                this.localStorageSvc,
            ),
            isAdmin: this.userSvc.isAdmin,
            isDelegateAdmin: this.userSvc.isDelegatedAdmin,
            isB2B: true,
        });

        const companyId = this.userSvc.isAdmin || this.userSvc.isDelegatedAdmin
            ? this.customerName.value
            : this.userSvc.company.id;
        const isB2B = SaleOrderType.IsB2B.toString();
        // Match getList(): B2B list always filters to Confirmed.
        const placeStatus = PlaceStatus.Confirmed;
        const orderField = this.currentSort?.active || '';
        const orderDirection = this.currentSort?.direction
            ? this.currentSort.direction.toUpperCase()
            : '';

        const extraFilters = {
            originCountry: this.originCountry.value,
            destinationCountry: this.destinationCountry.value,
            batchCountryOrigin: this.batchOriginCountry.value,
            batchCountryDestination: this.batchDestinationCountry.value,
            dateToEmpact: this.toDataEmpact.value
                ? (this.datePipe.transform(this.toDataEmpact.value, 'yyyy-MM-dd') || '')
                : '',
            dateFromEmpact:
                this.toDataEmpact.value && this.fromDataEmpact.value
                    ? (this.datePipe.transform(this.fromDataEmpact.value, 'yyyy-MM-dd') || '')
                    : '',
            amountType: this.amountType.value,
            ShopId: this.shopIdByfilter.value,
            customerCountry: '',
            deliveryDateTo: this.deliveryToDate.value
                ? (this.datePipe.transform(this.deliveryToDate.value, 'yyyy-MM-dd') || '')
                : '',
            deliveryDateFrom:
                this.deliveryFromDate.value && this.deliveryFromDate.value
                    ? (this.datePipe.transform(this.deliveryFromDate.value, 'yyyy-MM-dd') || '')
                    : '',
        };

        let start$;
        if (this.listOfSelectedItems?.length > 0) {
            const selectedIds = [...this.listOfSelectedItems];
            start$ = this.saleOrderSvc.startExportAsync(
                {
                    companyId: companyId ? companyId : '',
                    isB2B,
                    placeStatus,
                },
                {
                    itemIds: selectedIds,
                    ...(exportColumns?.length ? { exportColumns } : {}),
                },
            );
            this.listOfSelectedItems = [];
        } else {
            const query = this.saleOrderSvc.buildSaleOrderExportQuery(
                this.pageParams?.pageIndex + 1,
                this.searchStr.value,
                companyId,
                this.prepareSearchParams,
                orderField,
                orderDirection,
                false,
                isB2B,
                undefined,
                placeStatus,
                false,
                {
                    ...extraFilters,
                    batchId: this.batchIdfilter?.value || '',
                    batchPartnerId: this.partnerIdfilter?.value || '',
                    fileId: this.fileNameFilter?.value || '',
                },
                false,
            );
            start$ = this.saleOrderSvc.startExportAsync(
                query,
                exportColumns?.length ? { exportColumns } : {},
            );
        }

        this.exportPoller.prepareNewExport();
        this.dialog.open(ExportProgressDialogComponent, {
            width: '440px',
            disableClose: true,
            data: { alreadyInProgress: false },
        });
        this.exportPoller.startJobAndTrack(start$);
    }

    openHideShowFieldsPopup(): void {
        const dialogRef = this.dialog.open(HideShowFieldsComponent, {
            width: '500px',
            data: { fields: this.fieldList, settingName: 'B2B_SALES_ORDER_VISIBLITY_FIELD_RULE' }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (!result) {
                return;
            }
            this.fieldList = result;
            this.userSvc.hiddenFieldB2BEvent.next("updates");
            this.reloadList();
        });
    }

    findDuplicate(data) {
        const marketplaceOrderId = data.map(item => (item?.marketplace?.marketplaceOrderId?.length > 6 ?
            item?.marketplace?.marketplaceOrderId?.slice(-5) : item?.marketplace?.marketplaceOrderId));
        return marketplaceOrderId.filter((item, index) => marketplaceOrderId.indexOf(item) !== index);
    }

    addNewSO(data) {
        this.consolidateShipmentService.getShipmentById(data).subscribe((res) => {
            if (res) {
                this.addNewSaleOrder = true;
                this.consolidateShipments(res);
            }
        });
    }

    listUpdated(){
        // console.log('batch created from SO');
        this.reloadList();
    }

    consolidateShipments(data = null): void {
        const saleOrders = this.saleOrdersList.filter((so) => this.listOfSelectedItems.includes(so.id));

        const ids = [...this.listOfSelectedItems];

        // TO DO - Need to move all validations to backend
        // 1. Block combining Delivered/Canceled with active orders
        const hasFinalized = saleOrders.some(el => 
            deliveredStatuses.includes(el.status) || el.status === SaleOrderStatus.CANCELED
        );
        const hasActive = saleOrders.some(el => 
            !deliveredStatuses.includes(el.status) && el.status !== SaleOrderStatus.CANCELED
        );

        if (hasFinalized && hasActive) {
            this.notify.showError('Consolidate shipment could not combine Delivered or Canceled SO with other');
            return;
        }

        // 2. Block combining an Origin order with its own Refunded/Canceled linked order
        const hasLinkedPair = saleOrders.some(el => 
            el.linkedSaleOrderId && saleOrders.some(val => val.id === el.linkedSaleOrderId)
        );

        if (hasLinkedPair) {
            this.notify.showError('Consolidate shipment could not combine Origin and Canceled / Refunded SOs');
            return;
        }

        // 3. Strict block: Any Delivered order in the selection prevents consolidation
        const containsDelivered = saleOrders.some(el => deliveredStatuses.includes(el.status));

        if (containsDelivered) {
            this.notify.showError("Delivered sale orders cannot be consolidated");
            return;
        }

        /*if (!!saleOrders.find((el) => el.shipment?.orderId)) {
            this.notify.showError('Some of the selected SO already exist in another Imp Shipment');
            return;
        }*/

        if (!!saleOrders.find((el) => el.consolNumber !== null && el.consolNumber !== undefined)) {
            this.notify.showError('Selected items contain sale order which included to another Consol Shipment');
            return;
        }

        // if (!!saleOrders.find((el) => el.shipmentConsol !== null && el.shipmentConsol !== undefined && !this.addNewSaleOrder)) {
        //     this.notify.showError('selected items include sale orders that are already part of another consolidated shipment');
        //     return;
        // }

        const hasEUCountry = !!saleOrders.find(el => el.shippingCountry !== 'United Kingdom');
        const hasUKCountry = !!saleOrders.find(el => el.shippingCountry === 'United Kingdom');

        if (hasEUCountry && hasUKCountry) {
            this.notify.showError('Shipments with destination country UK can not be consolidated to shipments with country from EU');

            return;
        }

        if (this.addNewSaleOrder) {
            this.saleOrderSvc.getMultipleSOByIds(ids).subscribe((so) => {
                const dialogRef = this.dialog.open(ConsolidateShipmentsDetailsComponent, { width: '90vw', height: '80vh' });
                dialogRef.componentInstance.createMode = true;
                dialogRef.componentInstance.isEditable = !!data?.id;
                dialogRef.componentInstance.summaryPage = false;
                dialogRef.componentInstance.existingConsolId = data?.id;
                dialogRef.componentInstance.info = data;
                dialogRef.componentInstance.shipmentOrderType = OrderType.B2BImport;
                dialogRef.componentInstance.soOrderType = SaleOrderType.IsB2B;
                dialogRef.componentInstance.saleOrders = _.cloneDeep(so);
                dialogRef.componentInstance.existingSaleOrderIds = this.existingConsolOrderIds;
                dialogRef.componentInstance.subtype = data?.subtype;

                dialogRef.afterClosed().subscribe((result: any) => {
                    if (result.type == 'summaryPage' && result.status == 'open') {
                        this.summaryDialog(result.data, so)
                    }

                });
            });
        }
        else {
            const confirmDialog = this.dialog.open(ShipmentSubtypeSelectPopupComponent);
            
            // Check if any selected order is Delivered (including AfterShip sub-statuses) or Canceled
            confirmDialog.componentInstance.isOnlyReturn = saleOrders.some(el => 
                deliveredStatuses.includes(el.status) || 
                el.status === SaleOrderStatus.CANCELED
            );

            confirmDialog.afterClosed().subscribe(value => {
                if (value === undefined) {
                    return;
                }
                this.saleOrderSvc.getMultipleSOByIds(ids).subscribe((so) => {
                    const dialogRef = this.dialog.open(ConsolidateShipmentsDetailsComponent, { 
                        width: '90vw', 
                        height: '80vh' 
                    });
                    
                    dialogRef.componentInstance.createMode = true;
                    dialogRef.componentInstance.summaryPage = false;
                    dialogRef.componentInstance.info = data;
                    dialogRef.componentInstance.shipmentOrderType = OrderType.B2BImport;
                    dialogRef.componentInstance.soOrderType = SaleOrderType.IsB2B;
                    dialogRef.componentInstance.saleOrders = _.cloneDeep(so);
                    
                    // value is passed from the selection popup (Regular or Return)
                    dialogRef.componentInstance.subtype = value;

                    dialogRef.afterClosed().subscribe((result: any) => {
                        if (result?.type === 'summaryPage' && result?.status === 'open') {
                            this.summaryDialog(result.data, so);
                        }
                    });
                });
            });
        }
    }

    summaryDialog(data, so) {
        const dialogRef = this.dialog.open(ConsolidateShipmentsDetailsComponent, { width: '1000px', height: '600px' });
        dialogRef.componentInstance.createMode = false;
        dialogRef.componentInstance.summaryPage = true;
        dialogRef.componentInstance.info = data;
        dialogRef.componentInstance.shipmentOrderType = OrderType.B2BImport;
        dialogRef.componentInstance.saleOrders = _.cloneDeep(so);
        dialogRef.componentInstance.existingSaleOrderIds = this.existingConsolOrderIds;
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result.type == 'createPage' && result.status == 'open') {
                this.consolidateShipments(result.data)
            }
        });
    }

    openUploadDialog(): void {
        this.dialog.open(XlsxUploadPopupPopupComponent);
    }

    applyChanges(): void {
        if (!this.listOfSelectedItems.length) {
            this.notify.showError('Please select at least one SO');
            return;
        }

        let dialogRef = this.dialog.open(OriginCountryPopupDialog);

        dialogRef.componentInstance.countries = this.fullCountriesList;
        dialogRef.componentInstance.orderIds = this.listOfSelectedItems.map(el => Number(el));

        dialogRef.afterClosed().subscribe(value => {
            this.listOfSelectedItems = [];
            this.reloadList();
        })
    }

    recalculateTaxReport() {
        this.showLoader = true;
        this.saleOrderSvc.recalculateTaxReport(this.listOfSelectedItems).subscribe(res => {
            this.reloadList();
            this.listOfSelectedItems = [];
            this.notify.showSuccessMessage('Recalculation complete successfully.');
        });
    }

    syncWithAfterShip(event) {
        this.showLoader = true;
        const ids = event ? [event] : this.listOfSelectedItems;
        this.saleOrderSvc.syncWithAfterShip(ids).subscribe(res => {
            this.reloadList();
            this.listOfSelectedItems = [];
            this.notify.showSuccessMessage('Synchronization with AfterShip complete successfully.');
        }, error => {
            this.showLoader = false;
        });
    }

    createSpecificInvoice() {
        const dialogRef = this.dialog.open<SpecificInvoiceListDialogComponent>(SpecificInvoiceListDialogComponent, {
            maxHeight: '80vh',
            width: '890px',
            panelClass: 'inv-man-dialog'
        });
        dialogRef.afterClosed().subscribe(value => {
            if (!value) {
                return;
            }

            const selectedOrders = this.dataSource.filter(item => {
                return  this.listOfSelectedItems.includes(item.id);
            });
            const selectedTemplates = value;

            const dialogRef = this.dialog.open<ConfirmAssignComponent>(ConfirmAssignComponent);
            dialogRef.componentInstance.type = EAssignType.B2B;
            dialogRef.componentInstance.templateName = selectedTemplates.map(v => v.name)?.join(', ');
            dialogRef.componentInstance.selectedOrders = selectedOrders;

            dialogRef.afterClosed().subscribe(value => {
                if (value) {
                    this.showLoader = true;
                    this.invoiceManagementService.assignTemplates(selectedOrders.map(o => o.id), selectedTemplates.map(v => v.id), EAssignType.B2B)
                        .pipe(finalize(() => {
                            this.showLoader = false;
                        }))
                        .subscribe(res => {
                            this.listOfSelectedItems = [];
                            this.notify.showSuccessMessage('Assigning complete successfully')
                        }, error => {
                            this.notify.showError(error?.error?.message ? error.error.message : 'Something wrong!')
                        })
                }
            })
        })
    }

    uploadExcel(e): void {
        if (!e.target.files) {
            return;
        }
        const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
        if (!this.uploadFileSvc.excelFileFormats[0].split(', ').find(el => el === files[0].type)) {
            this.fileInput.nativeElement.value = '';
            this.notify.showError('Should contain only XLSX files');
            return;
        }
        //this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/${this.selectedShop}`);
        this.uploadFileSvc.uploadSeveralFile(files, `xlsx-sale-order-files/upload/file`);
        this.sub$.add(
            this.uploadFileSvc.allFilesLoaded().subscribe(data => {
                if (!data) {
                    return;
                }
                let file = data[0];
                if (!file) {
                    return;
                }
                file = JSON.parse(file.data);
                this.notify.showSuccessMessage('Uploaded successfully');
                this.fileInput.nativeElement.value = '';
                this.uploadFileSvc.filesLoadedObserver.next(null);
                //this.dialog.close();
            })
        );
    }
}